<template>
  <div class="">
    <button class="btn btn-primary" @click="openModal" v-t="`chat.widget.buttonText`">چت</button>

    <!-- Modal -->
    <div class="modal fade" id="chat-widget-2-modal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="">
              <h5 class="text-right" v-t="`chat.widget.modalTitle`"></h5>
              <chat-layout :chatUsers="userGroup" @startNewChat="startNewChat"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->

  </div>
</template>

<script>
import {defineComponent} from 'vue'
import {mapGetters} from "vuex";
import $ from 'jquery'
import ChatLayout from "../../Chat/Layout/ChatLayout1/ChatLayout.vue";


export default defineComponent({
  name: "ChatWidget2",
  components: {ChatLayout},
  props: {
    product: {},
  },
  data() {
    return {
      userGroup: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'User/getProfile',
      isAuthenticated: 'User/isAuthenticated'
    })
  },
  methods: {
    async openModal() {
      let checkResult = await this.checkUserHaveChatBefore()
      if (checkResult === false) {
        $('#chat-widget-2-modal').modal('show')
      } else {
        let routeData = this.$router.resolve({name: 'SingleChat', params: {slug: checkResult}});
        window.open(routeData.href, '_blank');
      }
    },
    startNewChat(res) {
      res = res.data.data
      const slug = res.data.slug;

      $('#chat-widget-2-modal').modal('hide')

      let routeData = this.$router.resolve({name: 'SingleChat', params: {slug: slug}});
      window.open(routeData.href, '_blank');

    },
    checkChatToken() {
      return localStorage.getItem('chat_token') == null
    },
    getCurrentUserToken() {
      if (!this.checkChatToken()) {
        return localStorage.getItem('chat_token')
      }
      return this.user.chat_token
    },
    async checkUserHaveChatBefore() {

      if (!this.isAuthenticated && this.checkChatToken()) { // is user not authenticated or don't have chat token
        return false
      }


      let currentUserToken = this.getCurrentUserToken();
      let productUserId = this.product.user.chat_token

      let form = {
        users: [
          currentUserToken,
          productUserId,
        ]
      };

      this.userGroup = form.users

      let checkResult = await this.$store.dispatch('Chat/checkUsersHaveChatBefore', form)
      let data = checkResult.data.data;

      if (data == false) {
        return false
      }

      return data.slug

    }
  }
})
</script>


<style scoped>
#chat-widget-2-modal :deep(.fixed-bottom) {
  position: relative !important;
}
</style>